import  "./LinksDetails.css";

const LinksDetails = function (props) {
    return(
        <div className="col-12 cardWrap">
        <div className="card">
            <img className="card-img img-fluid" src={ props.data.MOLinkDetailImage_Url} data-holder-rendered="true" />
            <div className="card-body">
                <div className="card-icon">
                        <img src={ props.data.MOLinkDetailIcon.ImageUrl} data-holder-rendered="true" />
                </div>
                <h4>{props.data.Title}</h4>
                <p className="card-text" dangerouslySetInnerHTML={{__html: props.data.ModLinkSubTitle}}></p>
            </div>
        </div>
    </div>
    )
}
export default LinksDetails;